import { Injectable, ComponentFactoryResolver, Injector, ApplicationRef, ComponentRef } from '@angular/core';
import { Subject} from 'rxjs/Subject';
import { HttpClient } from '../../common/http.client';
import { environment } from 'environments/environment';

@Injectable()
export class RealTimeService {

  private layerLoaded = new Subject<boolean>();

  layerLoaded$ = this.layerLoaded.asObservable();

  // compRef: ComponentRef<RealTimePopupComponent>;
  compRef: ComponentRef<any>;

  constructor(
    private http: HttpClient,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) {}

  getMVT(id, sql) {
    return this.http.post(`https://${environment.options['cartoAccount']}.carto.com/api/v1/map`, {
      layers: [ {
        id: id || 'layer0',
        options: {
          sql: sql,
        }
      }],
    }).map(response => { return response.json() })
  }

  popup(popup, properties) {
    return this._popup(popup, properties);
  }

  _popup(component, properties) {
    // TODO: Should be destroyed if (this.compRef) { this.compRef.destroy(); }
    const cmpFactory = this.resolver.resolveComponentFactory(component);
    this.compRef = cmpFactory.create(this.injector);
    this.compRef.instance.properties = properties;
    this.appRef.attachView(this.compRef.hostView);
    return this.compRef.location.nativeElement;
  }

  layerLoad(loaded: boolean) {
    this.layerLoaded.next(loaded);
  }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time/real-time.service.ts